<template>
  <div class='name-data-cell'>
    <span class="material-icons-round logo" :class="{ successful: !isVulnerable }" :style="`color: ${indicationIcon.color}`" v-if='!isVulnerable'>
      {{ indicationIcon.iconName }}
    </span>
    <custom-tooltip popper-class="light-tooltip" v-else>
      <div slot='buttonContent'>
        <span class="material-icons-round logo" :style="`color: ${indicationIcon.color}`"  @click='goToIssues'>
          {{ indicationIcon.iconName }}
        </span>
      </div>
      <div slot="content">
        <slot name="tooltip">
          {{ warningTooltip }}
        </slot>
      </div>
    </custom-tooltip>
    <div class="name-wrapper">
      <v-badge
        tile
        overlap
        :icon="badgeIcon"
        :content="badgeContent"
        class="manual-config-badge"
        :class="{'copied-badge': displayedCopiedBadge}"
        :value="displayedCopiedBadge"
      >
        <div class="name" @click='copyAsset'>{{ getName }}</div>
      </v-badge>
    </div>
  </div>
</template>

<script>
import { views } from '@/router/constants';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'NameDataTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTooltip,
  },
  data() {
    return {
      displayedCopiedBadge: false,
    };
  },
  methods: {
    async goToIssues() {
      await this.$router.push({ name: views.ISSUES, params: { search: `${this.item.email}` }});
    },
    async copyAsset() {
      const data = this.getName;
      await navigator.clipboard.writeText(data);
      this.displayedCopiedBadge = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.displayedCopiedBadge = false;
    },
  },
  computed: {
    badgeIcon() {
      return 'build';
    },
    badgeContent() {
      return this.$t('copied');
    },
    warningTooltip() {
      return this.$t('configuration.vulnerable.employee.tooltip');
    },
    getName() {
      return this.item.name;
    },
    issueStatsForEmployee() {
      return this.item.vulnerabilityData;
    },
    isVulnerable() {
      return Object.keys(this.issueStatsForEmployee).some(key => this.issueStatsForEmployee[key] > 0);
    },
    indicationIcon() {
      const issueStatsKeys = Object.keys(this.issueStatsForEmployee);
      if ((issueStatsKeys.includes('critical') && this.issueStatsForEmployee.critical > 0) || (issueStatsKeys.includes('high') && this.issueStatsForEmployee.high > 0)) {
        return { iconName: 'warning', color: '#E0255E' };
      }
      if (issueStatsKeys.includes('medium') && this.issueStatsForEmployee.medium > 0) {
        return { iconName: 'warning', color: '#e0ad42' };
      }
      if (issueStatsKeys.includes('low') && this.issueStatsForEmployee.low > 0) {
        return { iconName: 'warning', color: '#2459D5' };
      }
      return { iconName: 'check_circle', color: '#2baf69' };
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/design-system';
.name-data-cell{
  display: flex;
  align-items: center;
  .material-icons-round {
    margin-right: rem(10);
    &:hover {
      cursor: pointer !important;
    }
  }
  .name-wrapper {
    .manual-config-badge {
      max-width: 100%;
      .name {
        text-transform: capitalize;
        color: var(--text-primary);
        font-size: rem(14);
        font-family: $font-family-semibold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .copied {
        text-transform: capitalize;
        color: var(--text-secondary);
      }
    }
  }
}

</style>

<style lang="scss">
@import "~@/assets/styles/design-system";

.name-data-cell {
  .manual-config-badge {
    .v-badge__wrapper {
      .v-badge__badge {
        font-family: $font-family-medium !important;
        text-transform: capitalize;
        background: transparent !important;
        border: none !important;
        color: var(--text-secondary);
        .v-icon {
          font-size: rem(16);
          transform: rotate(180deg);
        }
      }
    }
    &.copied-badge {
      .v-badge__wrapper {
        .v-badge__badge {
          text-transform: capitalize;
          background: transparent !important;
          border: none !important;
          color: var(--text-secondary);
          right: rem(20) !important;
          inset: auto auto calc(100% - 1px) calc(100% - 30px) !important;
        }
      }
    }
  }
}
</style>
